<template src='./attribute.pug' lang='pug'></template>

<script>
export default {
  name: 'Attribute',

  props: {
    order: {
      type: Number
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    type: {
      type: Object,
      required: true,
      default: {}
    },
    possibleValues: {
      type: Array,
      required: true
    },
    validation: {
      type: String
    },
    inUse: {
      type: Boolean
    },
    mask: {
      type: String
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    }
  },

  computed: {
    transformedPossibleValues () {
      if (this.possibleValues.length > 0) {
        let transformedValues = []
        this.possibleValues.forEach(element => {
          transformedValues.push(element.valor || element.value || element)
        })
        return transformedValues.toString()
      }
      return '-'
    },
    btnRemoveTitle () {
      return this.inUse
        ? this.$t('conjuntoAtributo.validacao.atributoEmUsoExcluir')
        : ''
    }
  }
}
</script>

<style scoped>
.attribute > .att-field {
  display: inline-block;
}

.list-complete-item:hover {
  cursor: move;
  background-color: #f5f5f5;
}

.list-complete-item {
  padding-top: 18px;
  padding-bottom: 18px;
  height: auto;
  word-wrap: break-word;
  min-height: 58px;
  border: 1px solid #ddd;
  transition: all 1s;
}

.fa.action {
  margin: 0;
}

.att-field.order {
  margin-left: 30px;
}

.att-field.buttons {
  padding-right: 7px;
}
</style>



// WEBPACK FOOTER //
// Attribute.vue?55c4fb6d